export default __webpack_public_path__ + "static/logo-repubblica-italiana-2bdc4587840a6d68b899a513d220ff2d.jpg";